var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('div',{staticClass:"blue-border"}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.title))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizon"},[_c('hr')])
}]

export { render, staticRenderFns }